'use strict';

window.addEventListener('DOMContentLoaded', function()
{
    //console.log("DOMContentLoaded::root.js");

    $('#login-btn').css('pointer-events', 'auto');
    $('#google-sso-btn').css('pointer-events', 'auto');
    $('#microsoft-sso-btn').css('pointer-events', 'auto');

    // ログインボタンの連打対策
    $('#login-btn').on('click', onClickLoginBtns);
    $('#google-sso-btn').on('click', onClickLoginBtns);
    $('#microsoft-sso-btn').on('click', onClickLoginBtns);
})
window.addEventListener('beforeunload', function(){
    $('#login-btn').css('pointer-events', 'auto');
    $('#google-sso-btn').css('pointer-events', 'auto');
    $('#microsoft-sso-btn').css('pointer-events', 'auto');
})

// ログインボタンクリック時の連打対策
function onClickLoginBtns(event)
{
    console.log('click loginBtns');

    let elmId = event.currentTarget.id;
    $('#' + elmId).css('pointer-events', 'none');
}